import React from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import "./Gifting.css";
import birthday from "../assets/gift1.png";
import anniversary from "../assets/gift.png";
import puja from "../assets/gift3.png";
// import { Toast } from "bootstrap/dist/js/bootstrap.bundle.min";

const OCAS = [
  { key:"birthday", title:"Birthday",  img:birthday,  blurb:"Joyful treats & heartfelt notes" },
  { key:"anniversary", title:"Anniversary", img:anniversary,  blurb:"Celebrate love with elegance" },
  { key:"wedding", title:"Wedding", img:puja, blurb:"Blessings wrapped with purity" },
  { key:"pooja", title:"Pooja", img:puja, blurb:"Auspicious, sattvik selections" },
];

export default function GiftingLanding() {
  const navigate = useNavigate();
  return (
    <div className="gift-landing">
      <motion.section
        className="gift-hero"
        initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
      >
        <div className="glass">
          <h1>Thoughtful Gifting, Naturally 🎁🌿</h1>
          <p>Curated herbal gifts with personal touches—wraps, notes, and add-ons.</p>
          <Link to="/gifts/all" className="btn-cta">Explore All Gifts</Link>
        </div>
      </motion.section>

      <section className="occasion-grid">
        {OCAS.map((o, i) => (
          <motion.div
            key={o.key}
            className="occasion-card"
            whileHover={{ y:-4, scale: 1.01 }}
            initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i*0.06 }}
            onClick={() => navigate(`/gifts?occasion=${o.key}`)}
            style={{ cursor: "pointer" }}
            tabIndex={0}
            role="button"
            onKeyDown={e => { if (e.key === "Enter" || e.key === " ") navigate(`/gifts?occasion=${o.key}`); }}
          >
            <img src={o.img} alt={o.title} loading="lazy"/>
            <div className="txt">
              <h3>{o.title}</h3>
              <p>{o.blurb}</p>
              <Link to={`/gifts?occasion=${o.key}`} className="chip" onClick={e => e.stopPropagation()}>
                Shop {o.title}
              </Link>
            </div>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
